export const API_BASE = import.meta.env.DEV ? `${window.location.protocol}//${window.location.hostname}:8787` : '';
export const apiUrl = (path: string) => `${API_BASE}${path}`;
